// extracted by mini-css-extract-plugin
module.exports = {"videoButton":"clinical-portal-3__InCallButton__videoButton"};